import React from "react";
import PropTypes from "prop-types";
import { IconAlertCircle, IconCircleX } from "@tabler/icons-react";

const Alert = ({ type, ...props }) => {
  let Icon;
  let borderColor;
  let textColor;

  switch (type) {
    case "error":
      Icon = IconCircleX;
      borderColor = "border-danger-600";
      textColor = "text-danger-600";
      break;
    case "warning":
      Icon = IconAlertCircle;
      borderColor = "border-warning-400";
      textColor = "text-warning-400";
      break;
    default:
      break;
  }

  return (
    <div
      className={`flex items-center space-x-3 rounded border-l-4 bg-white px-4 py-3 text-sm font-medium leading-normal text-neutral-700 shadow md:text-base ${borderColor}`}
      role="alert"
    >
      {Icon && (
        <div>
          <Icon className={`w-7 flex-none stroke-2 ${textColor}`} />
        </div>
      )}
      <div>{props.children}</div>
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.string.isRequired,
};

export default Alert;
